export const tool = {
  pageNext: "Nächste",
  pagePrevious: "Vorherige",
  chooseTime: "Zeit auswählen"
};
